export class GtmState {}
export type State = GtmState;
